import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLastAccountLedgerProcessedConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLastAccountLedgerProcessedConfigQuery = { __typename?: 'Query', getLastAccountLedgerProcessedConfig?: { __typename?: 'LastAccountLedgerProcessedConfig', id: string, last_account_ledger_batch_number: string, last_account_ledger_processed_at: string, updated_at: string } | null };


export const GetLastAccountLedgerProcessedConfigDocument = gql`
    query GetLastAccountLedgerProcessedConfig {
  getLastAccountLedgerProcessedConfig {
    id
    last_account_ledger_batch_number
    last_account_ledger_processed_at
    updated_at
  }
}
    `;

/**
 * __useGetLastAccountLedgerProcessedConfigQuery__
 *
 * To run a query within a React component, call `useGetLastAccountLedgerProcessedConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAccountLedgerProcessedConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAccountLedgerProcessedConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastAccountLedgerProcessedConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetLastAccountLedgerProcessedConfigQuery, GetLastAccountLedgerProcessedConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastAccountLedgerProcessedConfigQuery, GetLastAccountLedgerProcessedConfigQueryVariables>(GetLastAccountLedgerProcessedConfigDocument, options);
      }
export function useGetLastAccountLedgerProcessedConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastAccountLedgerProcessedConfigQuery, GetLastAccountLedgerProcessedConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastAccountLedgerProcessedConfigQuery, GetLastAccountLedgerProcessedConfigQueryVariables>(GetLastAccountLedgerProcessedConfigDocument, options);
        }
export type GetLastAccountLedgerProcessedConfigQueryHookResult = ReturnType<typeof useGetLastAccountLedgerProcessedConfigQuery>;
export type GetLastAccountLedgerProcessedConfigLazyQueryHookResult = ReturnType<typeof useGetLastAccountLedgerProcessedConfigLazyQuery>;
export type GetLastAccountLedgerProcessedConfigQueryResult = Apollo.QueryResult<GetLastAccountLedgerProcessedConfigQuery, GetLastAccountLedgerProcessedConfigQueryVariables>;